export const panelId = "add-cost-panel";

export const saveFailedMessage = "Could not save. Please try again.";
